export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <header className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
      <div className="max-w-2xl">
        {eyebrow && (
          <div className="text-[11px] uppercase tracking-[0.25em] text-[#D4A652] mb-3 font-semibold">
            {eyebrow}
          </div>
        )}
        <h1 className="font-serif text-4xl md:text-5xl text-stone-900 leading-tight">{title}</h1>
        {description && (
          <p className="text-stone-600 mt-3 text-sm md:text-base leading-relaxed">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-3">{actions}</div>}
    </header>
  );
}
